import { useIntl } from 'react-intl';

export function useOptionalTranslation(code: string): string {
  const intl = useIntl();
  const messages = intl.messages;
  const message = code && messages[code];

  return message ? intl.formatMessage({ id: code }) : code;
}
